import { Component, ViewEncapsulation } from '@angular/core';
import { Worker } from '../_types/worker';
import { WorkersService } from '../_services/workers.service';
import { WorkerBankAccountsService } from '../_services/workers-bank-accounts.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { BanksService } from '../../common/_services/banks.service';
import { WorkerBankAccount } from '../_types/worker-bank-account';
import { firstValueFrom } from 'rxjs';
import { WorkerCapabilitiesService } from '../_services/workers-capabilities.service';
import { Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { WorkersCapabiliyComponent } from '../workers-capabiliy/workers-capabiliy.component';
import { WorkersZoneComponent } from '../workers-zone/workers-zone.component';
import { WorkersTimeRangesService } from '../_services/workers-time-ranges.service';
import { WorkersTimeRangeComponent } from '../workers-time-range/workers-time-range.component';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { CalendarsService } from '../../calendars/_services/calendars.service';
import { CalendarsEventsService } from '../../calendars/_services/calendars-events.service';
import moment from 'moment';
import { UsersService } from '../../users/_services/users.service';
import { StringUtilsService } from 'src/app/core/services/string-utils.service';
import { User } from '../../users/_types/user';
import { CountriesService } from '../../common/_services/countries.service';
import { GuardsShiftsService } from '../../guards-shifts/_services/guards-shifts.service';
import { WorkersVehicleComponent } from '../workers-vehicle/workers-vehicle.component';
import { WorkerEquipmentsService } from '../_services/workers-equipments.service';
import { WorkersEquipmentsComponent } from '../workers-equipments/workers-equipments.component';
import { WorkerVehiclesService } from '../_services/workers-vehicles.service';
import { WorkersVehiclesDetailComponent } from '../workers-vehicles-detail/workers-vehicles-detail.component';
import { TabViewChangeEvent } from 'primeng/tabview';
import { RolesService } from '../../roles/_services/roles.service';
import { WorkersFilesService } from '../_services/workers-files.service';
import { WorkersFileComponent } from '../workers-file/workers-file.component';
import { WorkerFile } from '../_types/worker-file';
import { AddSubworkerComponent } from './add-subworker/add-subworker.component';
import { FilesService } from '../../common/_services/files.service';
import { WorkerBillableItemsService } from '../_services/workers-billable-items.service';
import { WorkersBillableItemsComponent } from '../workers-billable-items/workers-billable-items.component';
import { WorkerZonesService } from '../_services/workers-zones.service';
import { WorkersCalendarsEventsModalComponent } from './calendars-events-modal/workers-calendars-events-modal.component';
import { WorkersCalendarsEventsService } from '../_services/workers-calendars-events.service';
import { CountriesRegionsService } from '../../common/_services/countries-regions.service';
import { LanguagesService } from '../../common/_services/languages.service';
import { WorkerRatesService } from '../../rates/_services/workers-rates.service';
import { WorkerRateComponent } from './worker-rate/worker-rate.component';
import { Country } from '../../common/_types/country';
import { WorkerGuardShift } from '../_types/worker-guard-shift';
import { WorkerGuardShiftsService } from '../_services/workers-guards-shifts.service';
import { WorkersGuardShiftComponent } from '../workers-guard-shift/workers-guard-shift.component';
import { WorkersEndReasonsService } from '../_services/workers-end-reasons.service';
import { ComunicationsComponent } from '../../comunications/communications/comunications.component';
import { CasesServicesService } from '../../cases/_services/cases-services.service';
import { AddressesService } from '../../common/_services/addresses.service';
import { Address } from '../../common/_types/address';
import { PaymentsMethodsService } from '../../common/_services/payments-methods.service';
import { WorkerSeizuresService } from '../_services/workers-seizures.service';
import { WorkersSeizureComponent } from '../workers-seizure/workers-seizure.component';
import { LoginService } from '../../login/login.service';
import { Validators } from '@angular/forms';
import { JobsService } from '../../cases/_services/jobs.service';
import { Job } from '../../cases/_types/job';
import { ProfessionalCategoriesService } from '../../common/_services/professional-categories.service';
import { DelegationsService } from '../../common/_services/delegations.service';
import { WorkerContractsService } from '../_services/workers-contracts.service';
import { WorkerContractComponent } from './worker-contract/worker-contract.component';
import { ConfigurationsService } from '../../common/_services/configurations.service';


@Component({
    selector: 'app-workers-detail',
    templateUrl: './workers-detail.component.html',
    styleUrls: ['./workers-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WorkersDetailComponent {

  public workerFormGroup!: RxFormGroup;
  public userFormGroup!: RxFormGroup;
  public worker: Worker = new Worker();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public banks: any = [];
  public countries: Country[] = [];
  public workerEndReasons: any = [];
  public workerCapabilities: any = [];
  public workerZones: any = [];
  public workerEquipments: any = [];
  public zones: any[] = [];
  public roles: any[] = [];
  public equipments: any = [];
  public rates: any = [];
  public workerTimeRanges: any = [];
  public workers: any = [];
  public subWorkers: any = [];
  public vehicles: any = [];
  public totalVehiclesRecords: number = 0;
  public billableItems: any = [];
  public workerSeizures: any = [];
  public totalBillableItemsRecords: number = 0;
  public totalCapabilitiesRecords: number = 0;
  public totalZonesRecords: number = 0;
  public totalEquipmentsRecords: number = 0;
  public totalRatesRecords: number = 0;
  public totalSubWorkersRecords: number = 0;
  public totalWorkersFiles: number = 0;
  public totalWorkerSeizuresRecords: number = 0;
  public calendars: any = [];
  public fromDate: any = null;
  public toDate: any = null;
  public calendarEvents: any = [];
  public workerCalendarEvents: any = [];
  public guardsShifts: any = [];
  public files: any[] = [];
  public activeIndex: number = 0;
  public rangeStartDate: any = null;
  public rangeEndDate: any = null;
  public countriesRegions: any = [];
  public today: Date = new Date();
  public visibleChangePass: boolean = false;
  public password: string = "";
  public workerGuardShifts: WorkerGuardShift[] = [];
  public totalPendingCaseServices: number = 0;
  public totalPendingJobsLiquidation: number = 0;
  public paymentMethods: any = [];
  public professionalCategories: any[]= [];
  public delegations: any[]= [];
  public workerContracts: any[] = [];
  public totalWorkerContractsRecords: number = 0;
  private lastGridWorkerContractsEvent: any;

  public workerTypes:any[] = [
    { name: 'Siniestros', value: 'Accidents' },
    { name: 'Activos Inmobiliarios', value: 'Assets' },
    { name: 'Siniestros y Activos Inmobiliarios', value: 'AccidentsAndAssets' }
  ];

  public businessTypes:any[] = [
    { name: 'Autónomo', value: 'Person' },
    { name: 'Empresa', value: 'Company' },
    { name: 'Plantilla', value: 'Staff' }
  ];

  public STAFF_DATA_REQUIRED: boolean = true;

  constructor(
    private rolesService: RolesService,
    private workersService: WorkersService,
    private workerBankAccountsService: WorkerBankAccountsService,
    private addresesService: AddressesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private banksService: BanksService,
    private workerCapabilitiesService: WorkerCapabilitiesService,
    private workerZonesService: WorkerZonesService,
    private workerEquipmentsService: WorkerEquipmentsService,
    private dialogService: DialogService,
    private workerRatesServices: WorkerRatesService,
    private workerVehiclesService: WorkerVehiclesService,
    private workerBillableItemsService: WorkerBillableItemsService,
    private workerTimeRangesService: WorkersTimeRangesService,
    private workerGuardShiftsService: WorkerGuardShiftsService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private calendarsService: CalendarsService,
    private calendarsEventsService: CalendarsEventsService,
    private workersCalendarsEventsService: WorkersCalendarsEventsService,
    private usersService: UsersService,
    private languageService: LanguagesService,
    private stringUtilsService: StringUtilsService,
    private countriesService: CountriesService,
    private countriesRegionsService: CountriesRegionsService,
    private guardsShiftsService: GuardsShiftsService,
    private workerFilesService: WorkersFilesService,
    private filesService: FilesService,
    private stringUtils: StringUtilsService,
    private workersEndReasonService: WorkersEndReasonsService,
    private caseServicesService: CasesServicesService,
    private jobsService: JobsService,
    private paymentsMethodsService: PaymentsMethodsService,
    private workerSeizureService: WorkerSeizuresService,
    private loginService: LoginService,
    private professionalCategoriesService: ProfessionalCategoriesService,
    private delegationsService: DelegationsService,
    private workerContractsService: WorkerContractsService,
    private configurationsService: ConfigurationsService
  ) {

    this.worker.bankAccount = new WorkerBankAccount();
    this.worker.workStartAddress = new Address();
    this.worker.user = new User();
    this.worker.hoursCaseService = 2;
    this.workerFormGroup = this.formBuilder.formGroup<Worker>(this.worker) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de operario");
    this.topbarService.addBreadcrumb("Operarios", "/workers");

    await this.loadConfigurations();
    
    this.loadCountries();
    this.loadCountriesRegions();
    this.loadWorkerEndReasons();
    this.loadProfessionalCategories();
    this.loadDelegations();

    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadWorker(id);
    } else {
      this.onTabChange({ index: 0, originalEvent: new Event('') });
      this.worker.address.countryCode = 'ES';
      this.workerFormGroup.patchValue(this.worker);
    }

    //si no tiene activada la cuenta bancaria, la desactivamos
    this.onChangeHasBankAccount();

    //actualizamos el enable access
    this.onEnableAccessChange();

    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE") || this.loginService.hasPermission("WORKERS.DELETE_GUARD_SHIFTS");

    let menuItems = [
      
      { label: 'Confirmaciones de turnos de guardia', icon: 'pi pi-clipboard', command: () => this.workerGardShiftStatusReport()},
      { label: 'Actividad de usuario', icon: 'pi pi-clipboard', command: () => this.userActivityReport()}
    
    ]

    this.topbarService.addAction("Acciones masivas", "pi pi-ellipsis-v",false, () => {
      
    }, menuItems);  

  }

  async loadConfigurations() {
     let filters = {
      code: new Filter(FilterOperation.equals, 'code', '', 'STAFF_DATA_REQUIRED')
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.configurationsService.all(params));
    if(response.meta['total'] > 0 && response.data[0].value == 'false'){
      this.STAFF_DATA_REQUIRED = false;
    }
    
  }

  async loadWorker(id: string) {
    this.worker = await firstValueFrom(this.workersService.get(id, { include: ['user', 'bankAccount', 'address', 'workStartAddress', 'parentWorker'] }));

    //cargamos tab 0
    let firstIdx = this.worker.parentWorkerId != null ? 1 : 0;
    this.activeIndex = firstIdx;
    this.onTabChange({ index: firstIdx, originalEvent: new Event('') });

    //cargamos usuario si tiene
    if (this.worker.userId != null) {
      let user: User = await firstValueFrom(this.usersService.get(this.worker.userId));
      this.worker.user = user;
    }

    //cargamos direccion si tienes
    /*if (!this.worker.usePrincipalAddressAsWorkStart && this.worker.workStartAddressId == null) {
      this.worker.workStartAddress = new WorkerAddress();
    }*/

    //si no tiene usuario, pero tiene activo el acceso
    if (this.worker.user == null && this.worker.enableAccess) {
      this.worker.user = new User();
      this.worker.user.userName = this.stringUtilsService.RandomString(8);
      this.worker.user.temporalPassword = this.stringUtilsService.RandomString(8);
      this.worker.user.password = this.worker.user.temporalPassword;
    }
    if (!this.worker.enableAccess) {
      //this.workerFormGroup.removeControl('user');
      //this.workerFormGroup.updateValueAndValidity();
    }
    this.workerFormGroup.patchValue(this.worker);

    this.onChangeHasBankAccount();
    this.onEnableAccessChange();
    this.onEnableUsePrincipalAddressAsWorkStartChange();

    this.loadEvents();
    this.loadCaseServices();
    this.loadPendingLiquidation();
  }

  async loadProfessionalCategories() {
    let response = await firstValueFrom(this.professionalCategoriesService.all({ page: { size: 1000 } }));
    this.professionalCategories = response.data;
  }
  async loadDelegations() {
    let response = await firstValueFrom(this.delegationsService.all({ page: { size: 1000 } }));
    this.delegations = response.data;
  }



  async loadPaymentMethods() {
    let response = await firstValueFrom(this.paymentsMethodsService.all({ page: { size: 1000 } }));
    this.paymentMethods = response.data;
  }

  async onTabChange(event: TabViewChangeEvent) {
    if (event.index == 0) {
      //bank accounts
      this.loadBanks();
    } else if (event.index == 1) {
      //capabilites
      this.loadCapabilities();
    } else if (event.index == 2) {
      //zones
      this.loadZones();
    } else if (event.index == 3) {
      //timeranges
      this.loadGuardShifts();
      this.loadTimeRanges();
      this.loadWorkerGuardShifts();
    } else if (event.index == 4) {
      //subworkes
      this.loadWorkers();//????
      this.loadSubWorkers();
    } else if (event.index == 5) {
      //vehivcles
      this.loadVehicles();
    } else if (event.index == 6) {
      //equipment
      this.loadEquipments();
    } else if (event.index == 7) {
      //configuration
      this.loadRoles();
      this.loadPaymentMethods();
    } else if (event.index == 8) {
      //calendar
      this.loadCalendars();
      this.loadEvents();
    } else if (event.index == 9) {
      this.loadBillableItems();
    } else if (event.index == 10) {
      //notes
    } else if (event.index == 11) {
      //DOCUMENTOS
      this.loadFiles();
    } else if (event.index == 12) {
      //baremos
      this.loadRates();
    }else if (event.index == 13) {
      //baremos
      this.loadWorkerSeizure();
    }else if(event.index == 14){
      this.loadWorkerContracts(this.lastGridWorkerContractsEvent);
    }
  }

  async loadBanks() {
    let response = await firstValueFrom(this.banksService.all({ page: { size: 0 } }));
    this.banks = response.data;
  }

  async loadCaseServices() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.worker.id),
      isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false),
      dateEnd: new Filter(FilterOperation.equals, 'dateEnd', '', null, true)
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.caseServicesService.all(params));
    this.totalPendingCaseServices = response.meta['total'];
  }

  async loadPendingLiquidation() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.worker.id),
      isForCompany: new Filter(FilterOperation.equals, 'isForCompany', '', false),
      isBillable: new Filter(FilterOperation.equals, 'isBillable', '', true),
      isReview: new Filter(FilterOperation.equals, 'isReview', '', true),
      transactionId: new Filter(FilterOperation.equals, 'transactionId', '', null, true),
    };
    let params: IParamsCollection = {
      fields: { jobs: 'total' },
      page: { size: 10000 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.jobsService.all(params));
    this.totalPendingJobsLiquidation = response.data.reduce((acc: number, job: Job) => {
      return acc + (job.total || 0);
    }, 0);
  }

  async loadCountries() {
    let countryId = null;
    if (this.workerFormGroup.value.address?.countryRegionId != null) {
      let country = this.countriesRegions.find((m: any) => m.id == this.worker.address?.countryRegionId);
      if (country != null) countryId = country.countryId;

    }

    let filters = {
      id: new Filter(FilterOperation.equals, 'id', "", countryId)
    };
    let params: IParamsCollection = {
      sort: ['name'],
    };
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.countriesService.all(params));
    this.countries = response.data;
  }
  async loadCountriesRegions() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.countriesRegionsService.all(params));
    this.countriesRegions = response.data;
  }

  async loadWorkerEndReasons() {
    let response = await firstValueFrom(this.workersEndReasonService.all());
    this.workerEndReasons = response.data;
  }

  async loadGuardShifts() {
    let response = await firstValueFrom(this.guardsShiftsService.all());
    this.guardsShifts = response.data;
  }

  async loadCapabilities() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };
    let params: IParamsCollection = {
      include: ['capability']
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.workerCapabilitiesService.all(params));
    this.workerCapabilities = response.data;
    this.totalCapabilitiesRecords = response.meta['total'];
  }

  async loadEquipments() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };
    let params: IParamsCollection = {
      include: ['equipment']
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.workerEquipmentsService.all(params));
    this.workerEquipments = response.data;
    this.totalEquipmentsRecords = response.meta['total'];
  }

  async loadRates() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };

    let params: IParamsCollection = {
      include: ['rate']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.workerRatesServices.all(params));

    this.rates = response.data;
    this.totalRatesRecords = response.meta['total'];
  }

  async loadRoles() {
    let filters = {
      workerAllowed: new Filter(FilterOperation.equals, 'workerAllowed', "", true)
    };

    let params: IParamsCollection = {}
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.rolesService.all(params));
    this.roles = response.data;
  }

  async loadZones() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };
    let params: IParamsCollection = {
      include: ['zone']
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.workerZonesService.all(params));
    this.workerZones = response.data;
    this.totalZonesRecords = response.meta['total'];
  }

  async loadVehicles() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };

    let params: IParamsCollection = {
      include: ['vehicle']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.workerVehiclesService.all(params));
    this.vehicles = response.data;
  }

  async loadBillableItems() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };

    let params: IParamsCollection = {
      include: ['business', 'tax']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.workerBillableItemsService.all(params));
    this.billableItems = response.data;
  }

  async loadTimeRanges() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };

    let params: IParamsCollection = {}

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.workerTimeRangesService.all(params));
    this.workerTimeRanges = response.data;
  }

  async loadWorkers() {
    let response = await firstValueFrom(this.workersService.all());
    this.workers = response.data;
  }

  async loadSubWorkers() {
    let filters = {
      parentWorkerId: new Filter(FilterOperation.equals, 'parentWorkerId', "", this.worker.id)
    };

    let params: IParamsCollection = {}

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.workersService.all(params));
    this.subWorkers = response.data;
    this.totalSubWorkersRecords = response.meta['total'];
  }

  async loadCalendars() {
    let response = await firstValueFrom(this.calendarsService.all({ page: { size: 0 } }));
    this.calendars = response.data;
    this.calendars.unshift({
      id: null,
      name: "Sin calendario"
    })
  }

  async loadWorkerSeizure() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id),
    };
    let params: IParamsCollection = {
      sort: [ '-date'],
     }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.workerSeizureService.all(params));
    this.workerSeizures = response.data;
  }


  addComunication(comunicationType: string | null, email: string | null, phoneNumber: string | null) {
    let ref = this.dialogService.open(ComunicationsComponent, {
      closable: true,
      modal: true,
      header: 'Enviar comunicación',
      width: '60%',
      data: {
        email: this.worker.email,
        comunicationType: comunicationType,
        phoneNumber: this.worker.phone1,
        model: this.worker,
        templateDestination: 'Worker'
      }
    });
  }

  async onEnableAccessChange() {
    //si no tiene usuario preparamos datos por si lo activa
    if (this.workerFormGroup.value.enableAccess) {
      if (this.worker.userId == null) {
        if (!this.worker.user) this.worker.user = new User();
        this.worker.user.userName = this.stringUtilsService.RandomString(8);
        if (this.worker.user.password == null || this.worker.user.password == "") {
          this.worker.user.temporalPassword = this.stringUtilsService.RandomString(8);
          this.worker.user.password = this.worker.user.temporalPassword;
        }

        //si no tiene idioma, lo asignamos por defecto español
        if (this.worker.user.languageId == null) {
          var languages = await firstValueFrom(this.languageService.all({ filter: FilterBuilder.fromObject({ cultureCode: new Filter(FilterOperation.equals, 'cultureCode', '', 'es-ES') }).build() }));
          if (languages.data.length == 0) {
            this.messageService.add({ closable: true, severity: 'error', detail: "No se ha podido activar el usuario de acceso por no haber encontrado el idioma por defecto Español." });
            return;
          }
          this.worker.user.languageId = languages.data[0].id!;
        }

        if (!this.worker.user.roleId && this.roles.length == 1) this.worker.user.roleId = this.roles[0].id;
      }
      if (this.worker.user) this.worker.user.name = this.worker.name;
      this.workerFormGroup.patchValue({ user: this.worker.user });

      this.workerFormGroup.get('user')?.enable();
      if (this.worker.userId) this.workerFormGroup.get('user.password')?.disable();
    } else {
      this.workerFormGroup.get('user')?.disable();
    }
  }

  async onEnableUsePrincipalAddressAsWorkStartChange() {
    //si no tiene usuario preparamos datos por si lo activa
    if (!this.workerFormGroup.value.usePrincipalAddressAsWorkStart) {
      this.workerFormGroup.get('workStartAddress')?.enable();
    } else {
      this.workerFormGroup.get('workStartAddress')?.disable();
    }
  }

  yearChanged(data: any) {
    this.fromDate = data.first_date;
    this.toDate = data.end_date;
    this.loadEvents();
  }

  async loadEvents() {
    if(this.worker.id == null || this.worker.id == "") return;

    this.calendarEvents = [];
    this.workerCalendarEvents = [];
    //Buscamos los del calendario
    if (typeof this.workerFormGroup.value.calendarId != "undefined" && this.workerFormGroup.value.calendarId != null) {
      let filters = {
        calendarId: new Filter(FilterOperation.equals, 'calendarId', '', this.workerFormGroup.value.calendarId),
        fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '', this.fromDate!.startOf("year").toISOString()),
        toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', new Date(this.toDate!).toISOString()),
      };

      let params: IParamsCollection = {
        page: { size: 5000 },
        filter: FilterBuilder.fromObject(filters).build()
      };

      let response = await firstValueFrom(this.calendarsEventsService.all(params));
      this.calendarEvents = response.data;
    }

    //Eventos del trabajador
    let filtersWorkerCalendarEvents = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.worker.id),
      fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '', this.fromDate!.startOf("year").toISOString()),
      toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', new Date(this.toDate!).toISOString()),
    };

    let paramsWorkerCalendarEvents: IParamsCollection = {
      page: { size: 5000 },
      include: ['calendarEventType'],
      filter: FilterBuilder.fromObject(filtersWorkerCalendarEvents).build()
    };

    let responseWorkerCalendarEvents = await firstValueFrom(this.workersCalendarsEventsService.all(paramsWorkerCalendarEvents));
    this.workerCalendarEvents = responseWorkerCalendarEvents.data;

  }

  daySelected(data: any) {
    let date: moment.Moment | null = null;
    let start: moment.Moment | null = null;
    let end: moment.Moment | null = null;
    let selectedDates: moment.Moment[] = [];

    var message = "--";

    if (data.type == "day") {
      date = moment(data.date.date);
      start = date;
      end = moment(start).endOf('day');
      message = "Día: " + date?.format('DD/MM/YYYY');
    }

    if (data.type == "range") {
      start = moment(data.start);
      end = moment(data.end);
      message = "Rango: " + start?.format('DD/MM/YYYY') + " - " + end?.format('DD/MM/YYYY')
    }

    if(data.type == "multi-day"){
      selectedDates = data.selectedDates.map((d: any) => moment(d.date));
      message = "Selección multiple de fechas: ";
      selectedDates.forEach((item) => {
        message += item.format('DD/MM/YYYY') + " - ";
      })
    }
    
    const ref = this.dialogService.open(WorkersCalendarsEventsModalComponent, {
      closable: true,
      modal: true,
      data: {
        workerId: this.worker.id,
        date: date,
        start: start,
        end: end,
        selectedDates: selectedDates
      },
      header: message,
      width: "1024px",
    });
    ref.onClose.subscribe(async (result: any) => {
     this.loadEvents();
    });
  }

  onChangeCalendar($event: any) {
    this.loadEvents();
  }

  onActiveChange(){
    if (!this.workerFormGroup.get('active')?.value) {
      this.workerFormGroup.controls['endDate']?.setValidators([Validators.required]);
      this.workerFormGroup.controls['endNotes']?.setValidators([Validators.required]);
      this.workerFormGroup.controls['workerEndReasonId']?.setValidators([Validators.required]);
    }else{
      this.workerFormGroup.controls['endDate']?.clearValidators();
      this.workerFormGroup.controls['endNotes']?.clearValidators();
      this.workerFormGroup.controls['workerEndReasonId']?.clearValidators();
    }
    this.workerFormGroup.updateValueAndValidity();
  }

  onTypeOfBusinessChange(){
     if (this.workerFormGroup.get('typeOfBusiness')?.value == 'Staff' && this.STAFF_DATA_REQUIRED) {      
      this.workerFormGroup.controls['socialSecurityNumber'].setValidators([Validators.required]);
      this.workerFormGroup.controls['professionalCategoryId'].setValidators([Validators.required]);
      this.workerFormGroup.controls['delegationId'].setValidators([Validators.required]);      
    }else{
      this.workerFormGroup.controls['socialSecurityNumber']?.clearValidators();
      this.workerFormGroup.controls['professionalCategoryId']?.clearValidators();
      this.workerFormGroup.controls['delegationId']?.clearValidators();
    }
    this.workerFormGroup.updateValueAndValidity();
  }

  async preSave(){
    let valid = this.formValidationService.validateForm(this.workerFormGroup);
    if (valid) 
    {      
      var worker = Object.assign(this.worker, this.workerFormGroup.value);

      //Comprobamos que no deje guardar si no ha rellenaod la información (no funciona lo del setValidator)
      if(this.STAFF_DATA_REQUIRED && worker.typeOfBusiness == 'Staff' && (worker.socialSecurityNumber == null || worker.socialSecurityNumber == "" || worker.professionalCategoryId == null || worker.delegationId == null)){
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Si el operario es personal de plantilla, los campos de número de seguridad social, categoría profesional y delegación son obligatorios." });
        return;
      }
      
      if(worker.id == null || worker.id == '00000000-0000-0000-0000-000000000000' || worker.id == ""|| worker.id == "undefined"){
        //Comprobamos si ya existe un trbaajado con ese nombre/teléfono o email.
        let filters = {
          name: new OrFilter([
            new Filter(FilterOperation.equals, 'name', '', worker.name),
            new Filter(FilterOperation.equals, 'email'),
            new Filter(FilterOperation.equals, 'phone1')
          ])
        };
        
        if(worker.email != null){
          if (filters.name.filters) filters.name.filters[1] = new Filter(FilterOperation.equals, 'email', '', worker.email);

        }
        if(worker.phone1 != null){
          if (filters.name.filters) filters.name.filters[2] = new Filter(FilterOperation.equals, 'phone1', '', worker.phone1);
        }

        let params: IParamsCollection = {
          page:{size: 0},
          filter: FilterBuilder.fromObject(filters).build()
        };
        let response = await firstValueFrom(this.workersService.all(params));
        if (response.meta['total'] > 0) {
          this.confirmationService.confirm({
            message: "Ya existe al menos un operario con el mismo nombre, teléfono o email. ¿Desea continuar?",
            header: "Continuar",
            acceptLabel: "Aceptar",
            rejectLabel: "Cancelar",
            //acceptButtonStyleClass: "p-button-danger",
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.save();
            },
            reject: (error: any) => { }
          });
          return;
        }else{
          this.save();
        }

      }else{
       this.save();
      }
    }
    else 
    {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }  


  async save() {

    //si se desactiva, los campos endDate, endNotes y endReason son obligatorios
    let valid = this.formValidationService.validateForm(this.workerFormGroup);
    if (valid) {
      this.worker = Object.assign(this.worker, this.workerFormGroup.value);

      //guardamos dirección
      if (this.worker.address?.addressLine1 != null) {
        let address: any = await firstValueFrom(this.addresesService.save(this.worker.address));
        this.worker.addressId = address.id;
      }

      //guardamos dirección de inicio de trabajo
      if (this.worker.workStartAddress?.addressLine1 != null) {
        let workStartAddress: any = await firstValueFrom(this.addresesService.save(this.worker.workStartAddress));
        this.worker.workStartAddressId = workStartAddress.id;
      }

      //guardamos cuenta bancaria
      if (this.worker.hasBankAccount && this.worker.bankAccount != null) {
        let bankAccount: any = await firstValueFrom(this.workerBankAccountsService.save(this.worker.bankAccount));
        this.worker.bankAccountId = bankAccount.id;
      }

      //guardamos operario
      let savedWorker = await firstValueFrom(this.workersService.save(this.worker));
      this.worker = Object.assign(this.worker, savedWorker);

      //comprobaciones de configuraciones y usuario asignado
      await this.saveConfigurations(this.worker);

      this.messageService.add({ closable: true, severity: 'success', summary: "Operario guardado correctamente." });

      this.loadWorker(this.worker.id!);
      
      if (this.workerFormGroup.get('id')?.value != "0" && this.workerFormGroup.get('id')?.value != "undefined" && this.workerFormGroup.get('id')?.value != "") {
        this.router.navigate(['workers']);
      }else{
        this.router.navigate(['workers', this.worker.id],);
      }

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el operario?",
      header: "Eliminar operario",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workersService.delete(this.worker.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Operario eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['workers']);
  }

  editWorkerCapability(workerCapability: any) {
    let ref = this.dialogService.open(WorkersCapabiliyComponent, {
      closable: true,
      modal: true,
      header: 'Detalles de especialidad',
      width: '500px',
      data: {
        workerCapabilityId: workerCapability ? workerCapability.id : null,
        workerId: this.worker.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadCapabilities();
    });
  }

  deleteWorkerCapability(workerCapability: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el servicio del operario?",
      header: "Eliminar servicio",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerCapabilitiesService.delete(workerCapability.id).subscribe({
          next: (data: any) => {
            this.loadCapabilities();
            this.messageService.add({ closable: true, severity: 'success', detail: "Servicio borrado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  editEquipment(workerEquipment: any) {
    let ref = this.dialogService.open(WorkersEquipmentsComponent, {
      closable: true,
      modal: true,
      header: 'Editar equipamiento del operario',
      width: '500px',
      data: {
        workerEquipmentId: workerEquipment ? workerEquipment.id : null,
        workerId: this.worker.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadEquipments();
    });
  }

  deleteWorkerEquipment(workerEquipment: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el equipamiento del operario?",
      header: "Eliminar equipamiento",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerEquipmentsService.delete(workerEquipment.id).subscribe({
          next: (data: any) => {
            this.loadEquipments();
            this.messageService.add({ closable: true, severity: 'success', detail: "Equipamiento eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  addRate(workerRate: any) {
    const ref = this.dialogService.open(WorkerRateComponent, {
      closable: true,
      modal: true,
      data: {
        existentRates: this.rates,
        workerRateId: workerRate.id,
        workerId: this.worker.id,
        rateId : workerRate ? workerRate.rateId : null
      },
      header: "Asignar baremo",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadRates();
    });
  }

  deleteRate(workerRate: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el baremo " + workerRate.rate?.name + "?",
      header: "Desasignar baremo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerRatesServices.delete(workerRate.id).subscribe({
          next: (data: any) => {
            this.loadRates();
            this.messageService.add({ closable: true, severity: 'success', detail: "Baremo desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  

  editWorkerZone(workerZone: any) {
    let ref = this.dialogService.open(WorkersZoneComponent, {
      closable: true,
      modal: true,
      header: 'Editar zona del operario',
      width: '500px',
      data: {
        workerZoneId: workerZone ? workerZone.id : null,
        workerId: this.worker.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadZones();
    });

  }

  deleteWorkerZone(workerZone: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la zona del operario?",
      header: "Eliminar zona",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerZonesService.delete(workerZone.id).subscribe({
          next: (data: any) => {
            this.loadZones();
            this.messageService.add({ closable: true, severity: 'success', detail: "Zona borrada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  editVehicle(vehicle: any) {
    const ref = this.dialogService.open(WorkersVehiclesDetailComponent, {
      closable: true,
      modal: true,
      data: {
        workerId: this.worker.id
      },
      header: vehicle.id ? vehicle.name : "Nuevo vehículo",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadVehicles();
    });

  }

  assignVehicle(workerVehicle: any) {
    const ref = this.dialogService.open(WorkersVehicleComponent, {
      closable: true,
      modal: true,
      data: {
        workerVehicleId: workerVehicle.id,
        workerId: this.worker.id
      },
      header: "Asignar vehículos",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadVehicles();
    });
  }

  deleteVehicle(vehicle: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el vehículo " + vehicle.vehicle.name + "?",
      header: "Desasignar vehículo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerVehiclesService.delete(vehicle.id).subscribe({
          next: (data: any) => {
            this.loadVehicles();
            this.messageService.add({ closable: true, severity: 'success', detail: "Vehículo desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  async editTimeRange(timerange: any) {
    const ref = this.dialogService.open(WorkersTimeRangeComponent, {
      closable: true,
      modal: true,
      data: {
        workerId: this.worker.id,
        id: timerange.id
      },
      header: "Detalles de franja horaria",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadTimeRanges();
    });

  }
  async deleteTimeRange(timerange: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la franja horaria?",
      header: "Eliminar franja horaria",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerTimeRangesService.delete(timerange.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Franja horaria eliminada correctamente." });
            this.loadTimeRanges();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  timeRangeFormat(time: string) {
    return time.substring(0, 5);
  }

  async loadWorkerGuardShifts() {
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };

    let params: IParamsCollection = {
      include: ['guardShift'],
      sort: ['guardShift.name'],
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.workerGuardShiftsService.all(params));
    this.workerGuardShifts = response.data;
  }

  async editWorkerGuardShift() {
    const ref = this.dialogService.open(WorkersGuardShiftComponent, {
      closable: true,
      modal: true,
      data: {
        workerId: this.worker.id
      },
      header: "Asignar turno",
      width: '350px'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadWorkerGuardShifts();
    });

  }
  async deleteWorkerGuardShift(workerGuardShift: WorkerGuardShift) {
    this.confirmationService.confirm({
      message: "¿Está seguro quitar el turno al operario?",
      header: "Quitar turno",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerGuardShiftsService.delete(workerGuardShift.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Tunro de guardia desaignado correctamente." });
            this.loadWorkerGuardShifts();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  async editSubWorker(subWorker: any) {
    await this.router.navigate(['workers', subWorker.id]);
    window.location.reload();
  }

  addSubWorker() {
    let ref = this.dialogService.open(AddSubworkerComponent, {
      closable: true,
      modal: true,
      header: 'Añadir suboperario',
      width: '80%',
      data: {
        parentWorkerId: this.worker.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadSubWorkers();
    });
  }

  async saveConfigurations(worker: Worker) {

    if (!worker.user) worker.user = new User();

    //copiamos datos de operario al usuario vionculado
    if (worker.user != null) {
      worker.user.name = this.worker.name;
      worker.user.email = this.worker.email;
    }

    // si enableAccess es true
    if (worker.enableAccess) {
      // si tiene usuario asignado, se activa el usuario
      if (worker.userId) {
        //activar usuario 
        let user = await firstValueFrom(this.usersService.get(worker.userId));

        user.userName = worker.user.userName;
        user.roleId = worker.user.roleId;
        user.active = true;
        await firstValueFrom(this.usersService.save(user));
      }

      //si no tiene usuario asignado, se crea un usuario y se asigna
      else {
        //ponemos idioma por defecto español
        var languages = await firstValueFrom(this.languageService.all({ filter: FilterBuilder.fromObject({ cultureCode: new Filter(FilterOperation.equals, 'cultureCode', '', 'es-ES') }).build() }));
        if (languages.data.length == 0) {
          this.messageService.add({ closable: true, severity: 'error', detail: "No se ha podido crear el usuario de acceso por no haber encontrado el idioma por defecto Español." });
          return;
        }

        //crear usuario
        let user: User = new User();
        user.isWorker = true;
        user.languageId = languages.data[0].id!;
        user.name = this.worker.name;
        user.roleId = worker.user.roleId;
        user.userName = worker.user.userName;
        //la contraseña inicial NO se guarda en claro: solo viaja su MD5 en Password. Quien da
        //el alta la sigue viendo en el formulario para comunicársela al usuario, pero no queda
        //almacenada en TemporalPassword.
        user.password = this.stringUtilsService.ToMD5(worker.user.password);
        let newUser = await firstValueFrom(this.usersService.save(user));
        worker.userId = newUser.id ? newUser.id : "";
        await firstValueFrom(this.workersService.save(worker));
      }
    }

    // si enableAccess es false, y tiene usuario asignado, se desactiva el usuario
    if (!worker.enableAccess && worker.userId) {
      let user = await firstValueFrom(this.usersService.get(worker.userId));
      user.active = false;
      await firstValueFrom(this.usersService.save(user));
    }
  }

  async changePassword() {
    this.visibleChangePass = true;
  }


  saveChangePassword(changeUserPassword: string) {
    if (changeUserPassword != null && changeUserPassword != "") {
      let user: User = this.workerFormGroup.get('user')?.value;
      user.password = this.stringUtils.ToMD5(changeUserPassword);
      this.usersService.save(user).subscribe({
        next: (data: any) => {
          this.messageService.add({ closable: true, severity: 'success', detail: "Contraseña modificada correctamente." });
          this.visibleChangePass = false;
          this.password = "";
        },
        error: (error: any) => {
          console.log(error);
        }
      });
    }
  }

  viewUser() {
    this.router.navigate(['users', this.worker.userId]);
  }


  async loadFiles() {

    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
    };
    let params: IParamsCollection = {
      include: ['file'],
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    }

    let response = await firstValueFrom(this.workerFilesService.all(params));
    this.files = response.data;
    this.totalWorkersFiles = response.meta['total'];
  }

  editFile(file?: WorkerFile) {
    const ref = this.dialogService.open(WorkersFileComponent, {
      closable: true,
      modal: true,
      data: {
        workerId: this.worker.id,
        typeOfBusiness: this.worker.typeOfBusiness,
        workerFileId: (file != null ? file.id : null)
      },
      header: file != null && file.id ? file.file.fileName : "Nuevo documento",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadFiles();
    });

  }

  deleteFile(file: WorkerFile) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el documento " + file.name + "?",
      header: "Eliminar documento",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerFilesService.delete(file.id).subscribe({
          next: (data: any) => {
            this.loadFiles();
            this.messageService.add({ closable: true, severity: 'success', detail: "Documento eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  downloadFile(id: any) {
    this.filesService.download(id);
  }

  onChangeHasBankAccount() {
    if (this.workerFormGroup.value.hasBankAccount) {
      this.workerFormGroup.get('bankAccount')?.enable();
    } else {
      this.workerFormGroup.get('bankAccount')?.disable();
      this.workerFormGroup.patchValue({ bankAccountId: null });
    }
  }


  editBillableItem(billableItem: any) {
    const ref = this.dialogService.open(WorkersBillableItemsComponent, {
      closable: true,
      modal: true,
      data: {
        workerBillableItemId: billableItem ? billableItem.id : null,
        workerId: this.worker.id
      },
      header: billableItem.id ? "Concepto facturable" : "Nuevo concepto facturable",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadBillableItems();
    });

  }


  deleteBillableItem(billableItem: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el concepto " + billableItem.description + "?",
      header: "Eliminar concepto facturable",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerBillableItemsService.delete(billableItem.id).subscribe({
          next: (data: any) => {
            this.loadBillableItems();
            this.messageService.add({ closable: true, severity: 'success', detail: "Concepto facturable eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }

  getTax(billableItem: any): number {
    return (billableItem.quantity * billableItem.price) * (billableItem.tax.percent / 100);
  }

  getTotalBillableItem(billableItem: any): number {
    return (billableItem.quantity * billableItem.price) + (billableItem.quantity * billableItem.price) * (billableItem.tax.percent / 100);
  }

  async workerGardShiftStatusReport() {
    this.router.navigate(['reports/visualization', '352f6894-033e-4e09-29ac-08dd66e699b7'], { 
      queryParams: { WorkerId: this.worker.id } 
    });
  }

  async userActivityReport() {
    this.router.navigate(['usersActivity'], {
      queryParams: { userId: this.worker.userId }
    });
  }
  
  //#region WorkerSeiz
  editWorkerSeizure(workerSeizure: any) {
    const ref = this.dialogService.open(WorkersSeizureComponent, {
      closable: true,
      modal: true,
      data: {
        workerSeizureId: workerSeizure ? workerSeizure.id : null,
        workerId: this.worker.id
      },
      header: workerSeizure.id ? "Embargo" : "Nuevo Embargo",
      width: '30%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadWorkerSeizure();
    });

  }

  deleteWorkerSeizure(workerSeizure: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el embargo " + workerSeizure.caseNumber + "?",
      header: "Eliminar embargo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerSeizureService.delete(workerSeizure.id).subscribe({
          next: (data: any) => {
            this.loadWorkerSeizure();
            this.messageService.add({ closable: true, severity: 'success', detail: "Concepto facturable eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }
  //#endregion WorkerSeiz


  async loadWorkerContracts($event: any){
    if(this.activeIndex == 14){
      this.lastGridWorkerContractsEvent = $event;
  
      let filters = {
        workerId: new Filter(FilterOperation.equals, 'workerId', "", this.worker.id)
      };
       let params: IParamsCollection = {
        page: { size: 1 },
        filter: FilterBuilder.fromObject(filters).build(),
        include: ['typeContract', 'colectiveAgreement']
      };
  
      let response = await firstValueFrom(this.workerContractsService.all(params));
      this.workerContracts = response.data;
      this.totalWorkerContractsRecords = response.meta['total'];;
    }
  }

  async editWorkerContract(workerContract: any) {
    let ref = this.dialogService.open(WorkerContractComponent, {
      closable: true,
      modal: true,
      header: 'Detalles de contrato',
      width: '500px',
      data: {
        workerContractId: workerContract ? workerContract.id : null,
        workerId: this.worker.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadWorkerContracts(this.lastGridWorkerContractsEvent);
    });
  }

  deleteWorkerContract(workerContract: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el contrato " + workerContract.name + "?",
      header: "Eliminar contrato",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerContractsService.delete(workerContract.id).subscribe({
          next: (data: any) => {
            this.loadWorkerContracts(this.lastGridWorkerContractsEvent);
            this.messageService.add({ closable: true, severity: 'success', detail: "Contrato eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }
}
